import { useCallback, useEffect } from "react";
import isEqual from "lodash/isEqual";
import { useLocation } from "react-router-dom";
import { QueryType, QueryFields } from "data/Types";
import qs from "query-string";
import { useSearch, useEffectOnce } from "hooks";

const HandleQueryString = () => {
  const location = useLocation();
  const search = useSearch(false);
  const handleHistoryChange = useCallback(
    (e) => {
      const params = qs.parse(location.search);
      const paramsQuery = {
        query: params.q,
        type: QueryType[params.type] || QueryType.ALL,
        fields: parseInt(params.fields, 10) || QueryFields.None,
        isAdvanced: typeof params.advanced !== "undefined",
      };
      if (!isEqual(paramsQuery, search.query) && params.q) {
        search.actions.abort(true);
        search.setQuery(paramsQuery);
        setImmediate(() => search.actions.execute());
      }
    },
    [search, location.search]
  );
  useEffectOnce(() => {
    handleHistoryChange();
  });
  useEffect(() => {
    window.addEventListener("popstate", handleHistoryChange);
    return () => window.removeEventListener("popstate", handleHistoryChange);
  }, [handleHistoryChange]);
  return null;
};

export { HandleQueryString };
